module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/third-party.b1d223cb.svg";